import { useRef } from "react";
import PassApi from "../../data/PassApi";
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput";
import FormControl from "../../gui/Form/FormControl";
import Validators from "../../gui/Form/Validators";
import Button from "../../gui/Button/Button";
import { useForm } from "../../gui/Form/Form";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider";

export default function NewPassword(){
    const {popOverlay} = useOverlay()
    const {addSnackbar} = useSnackbar()
    const name = useRef<ITextInput|null>(null)
    const {valid} = useForm()
    const onCreate = async () => {
        if (!name.current) return
        try {
            await PassApi.i.create(name.current.value!)
            onClose()
        }catch(e){
            addSnackbar(e)
        }
    }
    const onClose = () => popOverlay("passwordDlg")
    return <>
        <h2>New Password</h2>
        <div className="content">
            <FormControl validators={[Validators.Required("Name")]}>
                <TextInput placeholder="Name" ref={name} float={true}/>
            </FormControl>
        </div>
        <div className="actions">
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" color="primary" onClick={onCreate} disabled={!valid}>Create</Button>
        </div>
    </>
}